// import React from 'react';
import { Badge } from 'antd';

export interface ClaimBadgeProps {
  status: string;
  color: string;
}

const ClaimBadge = ({ status, color }: ClaimBadgeProps): JSX.Element => {
  const badgeColor =
    color === 'GREEN' ? '#7ED321' : color === 'RED' ? '#F1644A' : color === 'GREY' ? '#D9D9D9' : '#7ED321'; // 默认绿色

  return (
    <Badge
      count={status}
      style={{
        backgroundColor: badgeColor,
        height: '24px',
        fontFamily: 'Roboto700',
        fontSize: '15px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 32,
      }}
    />
  );
};

export default ClaimBadge;
